import React, {Component} from 'react';
import {injectStripe} from 'react-stripe-elements';
import {addPaymentMethod} from "../../store/actions/transactions";
import {connect} from "react-redux";

class Stripe extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        console.log("FINISHED TRANSACTION DID MOUNT: ", this.props.finishedTransactions)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log("FINISHED TRANSACTION DID UPDATE: ", this.props.finishedTransactions)

    }

    submit() {
        const orderForm = this.props.orderForm || this.props.corporateOrderForm;
        this.props.stripe.handleCardPayment(this.props.intent)
            .then((payload) => {
                if (payload.error) {
                    this.setState({
                        transaction: null
                    });
                    console.log('[error]', payload.error);
                } else {
                    this.setState({
                        transaction: "success"
                    });
                    this.props.paymentIntentSuccess(orderForm.transactionId, payload.paymentIntent.id);
                }
            });
    }

    render() {
        return (


            <div className={this.props.className}>
                <h1>Please wait, while we process your request</h1>
                <h2>This shouldn't take long!</h2>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        orderForm: state.orderFormReducer.orderForm,
        corporateOrderForm: state.corporateBundleReducer.orderForm,
        paymentIntent: state.transactionsReducer.paymentIntent,
        finishedTransactions: state.transactionsReducer.finished
    };
};

const mapDispatchToProps = dispatch => {
    return {
        paymentIntentSuccess: (transactionId, paymentMethod) => dispatch(addPaymentMethod(transactionId, paymentMethod))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(Stripe));

